import React from 'react'
import { useEffect } from 'hooks'
import { queryName } from 'utils'
import { connect } from 'react-redux'
import { T } from 'components/Translations'
import UserThumb, { UserThumbHorizontal } from 'components/UserThumb'
import Pagination from './Pagination'
import NoResults from './NoResults'
import { userListType } from 'common/types'
import { fetchUsers, watchList } from 'store/actions'
import StyledUserList from './StyledUserList'

const UserList = ({ vertical, title, Header, inverted, pagination, users, totalPages, ...props }) => {
  const Thumb = vertical ? UserThumbHorizontal : UserThumb
  const noResults = pagination && props.loaded && !users.length

  useEffect(() => {
    props.loaded || props.loading || props.fetchUsers(props.params)
  }, [props.loaded, props.loading])

  // useEffect(() => props.watchList(props.path), [props.path])

  return (
    <StyledUserList inverted={inverted} vertical={vertical}>
      {Header && <Header />}
      {title && <T as="h3" className="title" label={`sections/${title}`} />}

      {noResults ? (
        props.params.filters.match(/withMe|myFlirts|mutual/) ? (
          <T label="flirt/noMembers" as="div" className="no-members" />
        ) : (
          <NoResults />
        )
      ) : (
        <div className="users">
          {users.map(user => (
            <Thumb inverted={inverted} key={user.id} user={user} />
          ))}
        </div>
      )}
      {props.children && props.children}

      {pagination && totalPages > 1 && <Pagination totalPages={totalPages} />}
    </StyledUserList>
  )
}

const mapStateToProps = ({ users, router }, { limit, placeholders = limit, filter = '', pagination }) => {
  const params = pagination ? { ...router.location.query } : {}
  params.filters = params.filters || filter
  const page = params.page || 1
  const path = queryName(params)
  const { totalPages, pages = {}, searchId, loading = [] } = users[path] || {}
  if (searchId) {
    params.searchId = searchId
  }
  const loaded = pages[page] && !loading.includes(page)

  users = pages[page] || [...Array(placeholders)].map((e, i) => ({ id: i }))
  if (limit) {
    users = users.slice(0, limit)
  }
  return { path, params, totalPages, users, loading: loading.includes(page), loaded }
}

UserList.propTypes = userListType

export default connect(mapStateToProps, { fetchUsers, watchList })(UserList)
